import Vue from 'vue'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowLeft, faBackspace} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import SmartTable from 'vuejs-smart-table'
import './registerServiceWorker'

require('./assets/sass/main.scss');


library.add(faArrowLeft);
library.add(faBackspace);

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(SmartTable)

Vue.directive('title', {
  inserted: (el, binding) => document.title = binding.value,
  update: (el, binding) => document.title = binding.value
})


new Vue({
  render: h => h(App),
}).$mount('#app')
